<template>
    <div
        class="flex flex-col items-center justify-center flex-grow w-full mx-10"
    >
        <component
            ref="hardware"
            v-for="(hardware, index) in hardwareCards"
            :key="hardware.key"
            :is="hardware.model"
            :data="hardware.object"
            v-on:remove="removeHardware($event, index)"
        />
        <base-add-button
            title="Ajouter Matériel Informatique"
            @click="pushArray"
        />
        <div class="grid items-center justify-center w-full grid-cols-10 ">
            <base-primary-button
                title="Suivant"
                @click="nextStep"
                class="w-full col-span-6 col-start-3"
            />
            <div
                @click="skipStep"
                class="flex items-center justify-center col-span-2 col-start-9 p-3 mb-6 space-x-2 text-gray-500 cursor-pointer hover:underline hover:text-gray-800 "
            >
                <span>Ignorer cette étape</span>
                <svg
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 5l7 7-7 7M5 5l7 7-7 7"
                    ></path>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import TechHardware from "./components/TechHardware";
import { mapState } from "vuex";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        TechHardware
    },
    data() {
        return {
            hardwareCards: []
        };
    },
    mixins: [scrollToError],
    mounted() {
        this.hardwareCards = this.$store.getters[
            "EtudeTechnique/getTechHardware"
        ];
        this.$store.dispatch("forms/currentStep", "Matériel Informatique");
    },

    methods: {
        removeHardware(payload, index) {
            this.$store.dispatch("EtudeTechnique/removeHardware", payload);
            this.hardwareCards.splice(index, 1);
        },
        nextStep() {
            if (!this.checkForms() && this.hardwareLength >= 1) {
                this.$store.dispatch("EtudeTechnique/SaveTechHardware");
                this.$store.dispatch(
                    "forms/subStepComplete",
                    "Moyens d’exploitation"
                );
                this.$router.push({
                    name: "moyens_humains",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        skipStep() {
            this.$router.push({
                name: "moyens_humains",
                params: { uid: `${this.$store.state.user.bpiId}` }
            });
        },
        pushArray() {
            if (!this.checkForms()) {
                this.hardwareCards.push({
                    model: "tech-hardware",
                    key: new Date().getTime(),
                    object: {
                        id: new Date().getTime(),
                        image: null,
                        designation: "",
                        nombre: 1,
                        caracteristique: "",
                        etat: "",
                        prix: null,
                        nomFournisseur: "",
                        origine: ""
                    }
                });
                this.$refs.hardware[
                    this.$refs.hardware.length - 1
                ].scrollToRef();
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        checkForms() {
            let formsHasError = false;
            this.$refs.hardware.forEach(item => {
                if (!item.addTechHardware()) {
                    formsHasError = true;
                }
            });
            return formsHasError;
        }
    },
    computed: {
        ...mapState("EtudeTechnique", {
            hardwareLength: state => state.techHardware.length
        })
    }
};
</script>

<style></style>
